import axiosInstance from '@api/axios';
import { urls } from '@api/urls';
import {
  DetailUseCaseTemplate,
  GenerateUseCaseRequest,
} from '@app/types/use-case-template';
import { DuplicateDocumentTemplateFormFields } from '@features/admin-multi-document-agent/utils/demand-letter/duplicate-template-validator';

export const getUseCaseTemplate = async (
  id: number
): Promise<DetailUseCaseTemplate> => {
  const response = await axiosInstance.get(urls.useCaseTemplate.byId(id));

  return response.data;
};

export const generateUseCaseTemplate = async (
  id: number,
  data: GenerateUseCaseRequest
): Promise<DetailUseCaseTemplate> => {
  const response = await axiosInstance.post(
    urls.useCaseTemplate.generate(id),
    data
  );

  return response.data;
};

export const updateUseCaseTemplate = async (
  id: number,
  data: any
): Promise<DetailUseCaseTemplate> => {
  const response = await axiosInstance.patch(
    urls.useCaseTemplate.byId(id),
    data
  );

  return response.data;
};

export const deleteUseCaseTemplate = async (id: number): Promise<void> => {
  await axiosInstance.delete(urls.useCaseTemplate.byId(id));
};

export const deleteUseCaseFile = async (
  templateId: number,
  fileId: number
): Promise<void> => {
  await axiosInstance.delete(
    `/use-case-templates/${templateId}/files/${fileId}/`
  );
};

export const duplicateUseCaseTemplate = async (
  id: number,
  body: DuplicateDocumentTemplateFormFields
): Promise<DetailUseCaseTemplate> => {
  const response = await axiosInstance.post(
    urls.useCaseTemplate.duplicate(id),
    body
  );

  return response.data;
};

export const updateUseCaseTemplateOrder = async (
  id: number,
  direction: 'up' | 'down'
): Promise<DetailUseCaseTemplate> => {
  const response = await axiosInstance.patch(
    urls.useCaseTemplate.updateOrder(id),
    { direction }
  );

  return response.data;
};
